import { discussion } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveDiscussionRequestFailure(subject) {
      const result = getState().find((result) => result.subject === subject);

      return result ? result.request.isFailure : false;
    },
    isRetrieveDiscussionRequestPending(subject) {
      const result = getState().find((result) => result.subject === subject);

      return result ? result.request.isPending : false;
    },
    isRetrieveDiscussionRequestSuccess(subject) {
      const result = getState().find((result) => result.subject === subject);

      return result ? result.request.isSuccessful : false;
    },
    getDiscussion(subject) {
      const result = getState().find((result) => result.subject === subject);

      return result ? result.discussion : { ...discussion, uuid: "" };
    },
    getDiscussionCurrentPage(subject) {
      const result = getState().find((result) => result.subject === subject);

      return result ? result.page : 0;
    },
    canLoadMoreDiscussion(subject) {
      const result = getState().find((result) => result.subject === subject);

      return result ? result.canLoadMore : true;
    },
  };
}

export { createSelector };
